export default "__VITE_ASSET__CQLg2W0s__"